import React, { useContext, useCallback, useState, useEffect } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Button } from '@jutro/legacy/components';
import { focusNextElement, screenReaderAnnounce } from 'premier-capability-hooks';

import messages from './BoatInformationComponent.messages';
import metadata from './BoatInformationComponent.metadata.json5';
import BoatMainEngineTableComponent from '../BoatMainEngineTable/BoatMainEngineTableComponent';
import styles from './BoatInformationComponent.module.scss';

function BoatInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, index } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('BoatInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)
    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');

    const [manufacturerCodeSearchVisible, setManufacturerCodeSearchVisible] = useState(false);
    const [manufacturer, updateManufacturer] = useState('');
    const braFiePath = `${pathUpdated}.braFie.value`;


    if(modelVM && modelVM.value) {
        modelVM.value.isValidationReq = true;
    }

    const onCell = (item, index, { id: property }) => {
        return item[property];
    };

    const renderSelectButton = (item, index, { id: property }) => {
        return (
            <Button type='text'  onClick={(e) => onActionClick(item)} aria-label={`select ${item.manufacturer}`}>
                {messages.select}
            </Button>
        );
    };

    const loadData = ({ pageSize, page }) => {
        const paginationParams = {
            fromPage: page,
            pageSize: pageSize
        };

        return searchManufacturerCode(paginationParams);
    };

    const searchManufacturerCode = async(paginationParams) => {
       
        if(!paginationParams) {
            paginationParams = {
                fromPage: 0,
                pageSize: 10
            };
        }

        const reqParam = {
            manufacturer: manufacturer,
            pageNumber: paginationParams.fromPage,
            pageSize: paginationParams.pageSize
        }
        
        const response = await LoadSaveService.getRMManufacturerClassCodes_Ext(reqParam, authHeader);
        setManufacturerCodeSearchVisible(true);

        if(response != null){
            var resultCodes = response.resultClassCodes
            var objectArrayCodes = resultCodes.map((str) => ({ manufacturer: str }));
           
            screenReaderAnnounce(`Search results updated ${response.maxNumberOfResults} Search results are displayed`);
            
            return {
                rows: objectArrayCodes,
                numberOfRows: response.maxNumberOfResults
            };

        } else {
            return {
                rows: [],
                numberOfRows: 0
            };
        }
    };

    const clearSearchTexts = () => {
        updateManufacturer('');
    }

    const cancelSearch = () => {
        setManufacturerCodeSearchVisible(false);
        screenReaderAnnounce('Action cancelled');
        setTimeout(() => {
            focusNextElement(true,0, `modFie`); 
        }, 1000)
    }

    const openSearchPanel = () => {
        setManufacturerCodeSearchVisible(true);
        setTimeout(() => {
            focusNextElement(true, 0, 'manufacturerSearchInput');
        }, 5000) 
    } 

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onActionClick = (object, index) => {
        _.set(submissionVM, braFiePath, object.manufacturer);
        setManufacturerCodeSearchVisible(false);
        screenReaderAnnounce(`${object.manufacturer} is selected`);
        setTimeout(() => {
            focusNextElement(true,0, `modFie`); 
        }, 1500)
        updateWizardData(submissionVM);
    };

      // Close search panel on ESC key
        useEffect(() => {
            const handleEsc = (e) => {
                if (e.key === 'Escape') {
                    setManufacturerCodeSearchVisible(false);
                }
            };
            
            window.addEventListener('keydown', handleEsc);
            
            return () => window.removeEventListener('keydown', handleEsc);
        }, [setManufacturerCodeSearchVisible]);
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
		yeaFie: { 
            defaultValue: new Date().getFullYear(),
        },		
        braIfothpledesFie: {
            visible: _.get(modelVM.value, 'braFie') === 'Other'
        },
        ifOthExpFie: {
            visible: _.get(modelVM.value, 'proTypFie') === 'Oth'
        },
        ifothexpFie1: {
            visible: _.get(modelVM.value, 'hulMatFie') === 'Oth'
        }, 
        ifYesExpFie: {
            visible: _.get(modelVM.value, 'areTheAnyModPowOroOthFie') === true
        },
        boatMainEngineTableComponent: {
            id: `boatMainEngine${index}`,
            data: modelVM.mainEngineTable ? modelVM.mainEngineTable : [],
            updateWizardData,
            submissionVM,
            mainEngineTablePath: `${pathUpdated}.mainEngineTable`,
			boatInformationPath: pathUpdated
											
        },
        manufacturerCodeSearchBtn: {
            onClick: () => { searchManufacturerCode(); },
            visible: false
        },
        manufacturerAdapters: {
            visible: manufacturerCodeSearchVisible,
            key: manufacturer,
            onFetchData: loadData
        },
        manufacturerSearchContainer: {
            visible: manufacturerCodeSearchVisible
        },
        manufacturerAllContainer: {
            visible: manufacturerCodeSearchVisible
        },
        manufacturerCodeResetBtn: {
            onClick: () => { clearSearchTexts(); }
        },
        manufacturerCodeCancelBtn: {
            onClick: () => {cancelSearch(); }
        }, 
        manufacturerSearchIconBtn: {
            onClick: () => {openSearchPanel(); }
        },
        manufacturerSearchInput : {
            value: manufacturer,
            onValueChange: updateManufacturer
        },
        searchResultHeader: {
            visible: manufacturerCodeSearchVisible
        },
        manufacturerInput: {
            ariaLabel: 'Brand or Manufacturer required'
        }
        
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            onActionClick,
            onCell,
            renderSelectButton
        },
        resolveComponentMap: {
            boatMainEngineTableComponent: BoatMainEngineTableComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback((id, path) =>
         readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BoatInformationComponent.propTypes = wizardProps;
export default withRouter(BoatInformationComponent);
